import { useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'
import { PricingType } from '@guestgoodie/pricing'

export function useIntervals() {
  const { t } = useLingui()

  return useMemo(() => {
    return [
      {
        value: PricingType.Yearly.toString(),
        label: t`Yearly`
      },
      {
        value: PricingType.Monthly.toString(),
        label: t`Monthly`
      }
    ]
  }, [t])
}
